import { Referrer } from "./Enums/Referrer";
import { TimeRange } from "./Enums/TimeRange"
import { MilitaryBranch } from "./Enums/MilitaryBranch";
import { EmployeeLookup } from "./EmployeeLookup";
import { integrationProfile } from "./integrationProfile";

export class Screening {
    constructor() { }
    id : string;
    tanf : boolean;
    snap : boolean;
    ssi : boolean;
    felon : boolean;
    benefitNA : boolean;
    unemploymentComp : boolean;
    militaryService : boolean;
    referral : Referrer;
    tanfReceivedTimeFrame : TimeRange;
    tanfState : string;
    snapReceivedTimeFrame : TimeRange;
    snapState : string;
    unemployedTimeFrame : TimeRange;
    unemployedState : string;
    unemployedDate : Date;
    ssi60Days : boolean;
    militaryBranch : string;
    militaryDischarge : boolean;
    militaryCompensation : boolean;
    demographics : EmployeeLookup;
    eSignature : string;
    integrationProfile : integrationProfile;
    ageGroup: number;
    // acceptedDocuments : boolean = false;

}


// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/Models/Screening.ts